<template>
  <div class="columnBroadcast-container">
    <div class="baojing_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="iframeUrl"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iframeUrl: ''
    }
  },
  mounted() {
    const uname = this.$store.state.user.name
    const uId= this.$store.state.user.id
		if(uname=='pysl'||uname=='zhld'||uname=='erlangshen'||uname=='enshi'||uname=='SXWNPC'){
      if(uId>=26){
        this.iframeUrl='https://win.xyx-light.com:442/#/menu_device_management?username='+uname+'&password=123456'
      }else{
        this.iframeUrl='https://bc.xyx-light.com:442/#/menu_device_management?username='+uname+'&password=123456'
      }
			
		}else{
      this.iframeUrl='https://win.xyx-light.com:442/#/menu_device_management?username='+uname+'&password=123456'
    }
  }
}
</script>
<style lang="less" scoped>
.columnBroadcast-container {
  position: relative;
	width: 100%;
	height:100%;
	background:url('../../assets/datacount.png') no-repeat;
	background-size: cover;
  .baojing_main{
    position: absolute;
    top:-68px;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
  }

  #iframeContain{
    width: 100%;
    height: 100%;
    border: 0;
    padding: 0;
    margin:0;
    position: absolute;
  }
}
</style>